export type ScheduleViewName = 'Day' | 'Week' | 'Month' | 'Year';

function formatIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Visible range for GET /events (end exclusive). */
export function calculateScheduleViewDateRange(
  anchor: Date,
  view: ScheduleViewName
): { startDate: string; endDate: string } {
  if (view === 'Day') {
    const start = new Date(anchor.getFullYear(), anchor.getMonth(), anchor.getDate());
    const end = new Date(start);
    end.setDate(start.getDate() + 1);
    return { startDate: formatIsoDate(start), endDate: formatIsoDate(end) };
  }

  if (view === 'Week') {
    const dayOfWeek = anchor.getDay();
    const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    const start = new Date(
      anchor.getFullYear(),
      anchor.getMonth(),
      anchor.getDate() - daysToMonday
    );
    const end = new Date(start);
    end.setDate(start.getDate() + 7);
    return { startDate: formatIsoDate(start), endDate: formatIsoDate(end) };
  }

  if (view === 'Year') {
    const start = new Date(anchor.getFullYear(), 0, 1);
    const end = new Date(anchor.getFullYear() + 1, 0, 1);
    return { startDate: formatIsoDate(start), endDate: formatIsoDate(end) };
  }

  const firstDayOfMonth = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
  const dayOfWeek = firstDayOfMonth.getDay();
  const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const calendarStartDate = new Date(firstDayOfMonth);
  calendarStartDate.setDate(firstDayOfMonth.getDate() - daysToSubtract);
  const calendarEndDate = new Date(calendarStartDate);
  calendarEndDate.setDate(calendarStartDate.getDate() + 42);
  return {
    startDate: formatIsoDate(calendarStartDate),
    endDate: formatIsoDate(calendarEndDate),
  };
}
